var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChair = function SvgChair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13v-2c0-1.1.9-2 2-2s2 .9 2 2c0 .6.4 1 1 1h8c.6 0 1-.4 1-1 0-1.1.9-2 2-2s2 .9 2 2v2c0 .4-.1.8-.3 1.1-.6.9-1.7 1.8-1.7 2.9h-2v-2H5v2H3c0-1.1-1.1-2-1.7-2.9-.2-.3-.3-.7-.3-1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7h.6C5.9 7 7 8.1 7 9.4c0 .3.3.6.6.6h4.8c.3 0 .6-.3.6-.6C13 8.1 14.1 7 15.4 7h.6V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3z"
  })));
};
export default SvgChair;